module.exports = __webpack_public_path__ + "img/classiccar-1.f3a6bab2.jpg";